export enum Activite
{
    Automobile = 1,
    Agricole = 2,
    Moto = 3,
    Loisirs = 4,
    EspacesVerts = 5,
    Truck = 6
}